import { Stack } from "@mui/material";
import { Theme } from "klayowebshared";
import { debounce } from "lodash";
import { SyntheticEvent, useCallback, useEffect, useMemo, useState } from "react";
import { useLocale } from "../../providers/LocaleProvider";
import { Dialog } from "../dialogs/Dialog";
import { MultiAttributeSelector } from "./MultiAttributeSelector";

interface SettingCompetenciesSelectorProps {
  onClose?: () => void;
  onShowNewCategoriesialog?: () => void;
  onSave?: (categories: any[]) => void;
  theme?: typeof Theme;
  initialSelectedCategories?: any[];
  categories: any[];
  onSearch?: (searchText: string) => void;
  isLoading?: boolean;
  open?: boolean;
}

export const SettingCompetenciesSelector = (props: SettingCompetenciesSelectorProps) => {
  const {
    onClose,
    onShowNewCategoriesialog,
    onSave,
    theme,
    initialSelectedCategories = [],
    categories,
    onSearch,
    isLoading,
    open
  } = props;

  const { translate } = useLocale();
  const [selectedCategories, setSelectedCategories] = useState<any[]>([]);

  const debouncedSearchCategories = useCallback(
    debounce((searchText: any) => onSearch?.(searchText), 500),
    []
  );

  const handleAttributesChange = (e: SyntheticEvent<Element, Event> | null, selected: any) => {
    setSelectedCategories(selected);
  };

  const handleSave = () => {
    if (onSave) onSave(selectedCategories);
  };

  const categoriesFiltered = useMemo(() => {
    return categories;
  }, [categories]);

  useEffect(() => {
    setSelectedCategories(initialSelectedCategories);
  }, [initialSelectedCategories]);

  return (
    <Dialog
      open={open}
      theme={theme}
      onClose={onClose}
      fullWidth={true}
      maxWidth='sm'
      title={translate("common.filters")}
      actions={[
        {
          label: translate("common.apply"),
          primary: true,
          disabled: selectedCategories.length === 0,
          onClick: handleSave
        },
        {
          label: translate("common.cancel"),
          onClick: onClose
        }
      ]}
    >
      <Stack direction='column' spacing={2}>
        <div>{translate("settingsViews.competencies.categories")}</div>

        <MultiAttributeSelector
          label={null}
          items={categoriesFiltered}
          values={selectedCategories}
          onNewItemClick={onShowNewCategoriesialog}
          getItemId={(attr: any) => attr.attributeCategoryId}
          onChange={handleAttributesChange}
          hasNewItem={false}
          isLoading={isLoading}
          placeHolder={translate("common.search")}
          translate={translate}
        />
      </Stack>
    </Dialog>
  );
};
